export default __webpack_public_path__ + "static/media/portfoliowebsite.06c47da8.JPG";